import React from 'react';
import { string } from 'prop-types';

export const AgiLogo = ({ width, height, fill }) => {
  const logoWidth = width || 240;
  const logoHeight = height || 29;
  return (
    <svg
      width={`${logoWidth}px`}
      height={`${logoHeight}px`}
      viewBox="0 0 240 29"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="SYMBOLS"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="uti/logo/AGI_grow/green"
          transform="translate(0.000000, 1.000000)"
        >
          <g id="Logo" transform="translate(-0.089109, -1.293069)">
            <path
              d="M45.0131639,18.4142187 L48.6521672,18.4142187 L47.9667061,21.5233872 C47.02705,21.9165788 46.0299442,22.0597642 45.0281166,22.0597642 C43.6540466,22.0597642 42.7167514,21.5953587 42.3216866,20.5226046 C42.0194857,19.7006144 42.174521,17.9854201 42.7254082,15.483085 C43.2046801,13.3027276 43.9121766,10.7655431 44.6598092,9.72915357 C45.4074417,8.69200648 46.6201805,7.90638083 48.2169663,7.90638083 C48.8851137,7.90638083 49.4847938,8.04956622 49.859397,8.37078635 C50.2340003,8.69200648 50.4504203,9.2283835 50.3064026,10.0503737 L60.2569988,10.0503737 C61.4744595,4.01007151 57.7418054,1.40091551 49.4997464,1.40091551 C39.5499372,1.40091551 33.5838292,7.08439062 31.8453866,14.9830725 C30.1077311,22.8817544 33.5704505,28.5705327 43.2235676,28.5705327 C47.6046946,28.5705327 52.5823536,27.8856671 56.9682025,26.8492776 L59.9414192,13.3390921 L46.1298909,13.3390921 L45.0131639,18.4142187 Z"
              id="Fill-2"
              fill={fill || '#006332'}
            />
            <polygon
              id="Fill-5"
              fill={fill || '#006332'}
              points="59.0792808 28.8604601 69.6980244 28.8604601 75.3760972 2.10548977 64.7573535 2.10548977"
            />
            <path
              d="M88.7417216,16.5758112 C92.2917959,16.5412502 97.7329872,17.0470983 105.884543,18.8882601 L106.499963,16.1422271 C103.891906,15.7243525 98.6592646,15.4376528 88.7417216,16.5758112"
              id="Fill-7"
              fill={fill || '#006A35'}
            />
            <path
              d="M76.7068045,23.8487927 L76.083515,26.6238884 C87.4971101,25.7370832 95.7918969,27.2326343 101.115041,28.8664297 L103.6444,28.8664297 L103.714441,28.5490964 C91.4343794,24.6421261 80.932109,23.9556178 76.7068045,23.8487927"
              id="Fill-9"
              fill={fill || '#006A35'}
            />
            <path
              d="M84.3853059,17.5549888 C95.2928718,21.903398 101.088205,25.3249426 103.980362,27.3671868 L105.387486,21.1014244 C102.884884,20.3630746 92.1740635,17.3554772 84.3853059,17.5549888"
              id="Fill-11"
              fill={fill || '#006A35'}
            />
            <path
              d="M78.1158951,17.5695987 L77.3454401,21.0013545 C85.8401202,21.2142191 92.3217012,22.7812488 96.9460055,24.4959485 C87.266131,19.8176383 81.3708513,18.1453545 78.1158951,17.5695987"
              id="Fill-13"
              fill={fill || '#006A35'}
            />
            <path
              d="M81.6047423,2.03526799 L78.6149989,15.3499149 C80.2967787,15.9665155 81.8817598,16.5689776 83.3746641,17.15573 C83.7870424,17.027697 84.2151605,16.8988785 84.6582312,16.7708455 C90.4071322,14.283235 98.5264221,10.9410238 107.577498,11.3416178 L109.669296,2.03526799 L81.6047423,2.03526799 Z"
              id="Fill-15"
              fill={fill || '#006332'}
            />
            <path
              d="M88.1657298,15.8509716 C93.5597021,14.5800673 100.260064,13.6704832 106.873071,14.482668 L107.17055,12.8457307 C106.197054,12.8033149 101.797039,11.7476317 88.1657298,15.8509716"
              id="Fill-18"
              fill={fill || '#006332'}
            />
            <path
              d="M125.685302,17.8299114 L126.837807,12.5983325 L140.667876,12.5983325 L137.65649,26.5246483 C133.269533,27.5930693 128.287734,28.2930693 123.900777,28.2930693 C114.2346,28.2930693 110.777083,22.4351746 112.52443,14.2930693 C114.271778,6.15096404 120.257372,0.293069307 130.220969,0.293069307 C138.474397,0.293069307 142.192157,2.98254299 140.965296,9.20885878 L131.001699,9.20885878 C131.150409,8.36149036 130.927344,7.80885878 130.555568,7.47727983 C130.183792,7.14570089 129.58895,6.99833246 128.919753,6.99833246 C127.321116,6.99833246 126.094255,7.80885878 125.350703,8.87727983 C124.607151,9.94570089 123.900777,12.5614904 123.417468,14.8088588 C122.859804,17.3878061 122.711093,19.1562272 123.008514,20.0035956 C123.38029,21.1088588 124.346908,21.5878061 125.722479,21.5878061 C126.726274,21.5878061 127.692892,21.4404377 128.65951,21.0351746 L129.328707,17.8299114 L125.685302,17.8299114 Z M140.336052,27.5930693 L146.024225,0.993069307 L161.899061,0.993069307 C167.66159,0.993069307 170.672975,2.72464825 169.632003,7.73517457 C168.962806,10.7930693 167.178281,13.1141219 162.940034,14.0720167 L162.940034,14.1457009 C165.468111,14.3667535 166.657794,15.5088588 166.73215,17.5351746 C166.843682,19.8193851 165.95142,23.5772798 166.323196,27.5930693 L155.913467,27.5930693 C155.690402,25.6035956 156.099355,22.250964 156.210888,19.9667535 C156.285243,18.6404377 155.727579,18.1246483 154.017409,18.1246483 L152.790549,18.1246483 L150.74578,27.5930693 L140.336052,27.5930693 Z M154.054587,12.082543 L154.946849,12.082543 C156.991618,12.082543 158.66461,11.382543 159.073563,9.39306931 C159.482517,7.44043773 158.218479,7.03517457 156.136533,7.03517457 L155.169915,7.03517457 L154.054587,12.082543 Z M180.862413,14.2930693 C179.524019,20.4457009 180.564992,21.3667535 182.200807,21.3667535 C183.836621,21.3667535 185.24937,20.4457009 186.587764,14.2930693 C187.851802,8.28780615 186.95954,7.2193851 185.24937,7.2193851 C183.539201,7.2193851 182.126452,8.28780615 180.862413,14.2930693 Z M169.857843,14.2930693 C171.642368,6.00359562 177.479251,0.293069307 186.736474,0.293069307 C195.993697,0.293069307 199.376859,6.00359562 197.592334,14.2930693 C195.807809,22.582543 189.970926,28.2930693 180.713703,28.2930693 C171.45648,28.2930693 168.073318,22.582543 169.857843,14.2930693 Z M200.494962,27.5930693 L200.383429,0.993069307 L209.900895,0.993069307 L208.599679,17.7193851 L208.674035,17.7193851 L214.733984,0.993069307 L225.738554,0.993069307 L224.660404,17.7193851 L224.734759,17.7193851 L230.571643,0.993069307 L240.089109,0.993069307 L228.60123,27.5930693 L217.076173,27.5930693 L218.265856,10.350964 L218.191501,10.350964 L212.020019,27.5930693 L200.494962,27.5930693 Z"
              id="GROW"
              fill={fill || '#006332'}
            />
            <path
              d="M14.3638389,2.29306931 L0.0891089109,29.2930693 L10.2780303,29.2930693 L12.2685524,24.9547744 L19.9612471,24.9547744 L20.0888548,29.2930693 L31.0891089,29.2930693 L28.1509816,2.29306931 L14.3638389,2.29306931 Z M19.7343891,8.20244045 L19.8092207,8.20244045 L19.7863774,18.3732173 L15.2523664,18.3732173 L19.7343891,8.20244045 Z"
              id="Fill-1"
              fill={fill || '#006332'}
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

AgiLogo.propTypes = {
  fill: string,
  width: string,
  height: string,
};



// WEBPACK FOOTER //
// ./src/common/svg/AgiLogo.js